import TagDescription from './TagDescription'

export default TagDescription
